import { useCallback } from 'react'

import { useNavigate, type NavigateOptions } from 'react-router'

import { useAuth } from '@/hooks/use-auth'

export function useCountryNavigate() {
  const navigate = useNavigate()
  const { user } = useAuth()
  const prefix = user?.localidade === 'pt-BR' || !user?.localidade ? '' : `/${user.localidade}`

  return useCallback(
    (path: string, options?: NavigateOptions) => {
      navigate(`${prefix}${path}`, options)
    },
    [navigate, prefix],
  )
}
